import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Select } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./Form.css";

const { Item: ItemForm } = Form;

export const OPCOES_COR = [
  { key: '#FFFFFF', label: 'BRANCO', color: '#FFFFFF' },
  { key: '#E6E6E6', label: 'CINZA', color: '#E6E6E6' },
  { key: '#CEECF5', label: 'AZUL', color: '#CEECF5' },
  { key: '#81F7F3', label: 'CIAN', color: '#81F7F3' },
  { key: '#A9F5BC', label: 'VERDE', color: '#A9F5BC' },
  { key: '#F5A9A9', label: 'VERMELHO', color: '#F5A9A9' },
  { key: '#F5DA81', label: 'LARANJA', color: '#F5DA81' },
  { key: '#F5F6CE', label: 'AMARELO', color: '#F5F6CE' },
]


export default class StatusProducaoForm extends Component {
  state = {
    registro: {
      sp_idf: '',
      sp_descricao: '',
      sp_cor: { key: '#FFFFFF', label: "" }
    },
    sp_cor: { key: '#FFFFFF', label: "" }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
        sp_cor: { key: this.props.registroSelecionado.sp_cor.key, label: "" }
      }, () => {
        this.refs.sp_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.sp_descricao) || (this.state.registro.sp_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if ((!this.state.registro.sp_abrev) || (this.state.registro.sp_abrev === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Abreviatura' });
      return;
    }
    if (!this.state.registro.sp_idf) {
      if ((this.state.registro.sp_descricao.toUpperCase() === 'PENDENTE') || (this.state.registro.sp_descricao.toUpperCase() === 'ENTREGUE') || (this.state.registro.sp_descricao.toUpperCase() === 'PRODUÇÃO')) {
        Modal.warning({ title: 'Aviso!', content: 'Descrição não permitida' });
        return;
      }
    }

    const reg = {
      sp_idf: this.state.registro.sp_idf,
      sp_descricao: this.state.registro.sp_descricao,
      sp_abrev: this.state.registro.sp_abrev,
      sp_cor: this.state.registro.sp_cor.key,
    }

    this.props.onSalvarClick(reg);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { sp_idf, sp_descricao, sp_abrev, sp_cor } = this.state.registro;

    // console.log('StatusProducaoForm.this.state: ', this.state);

    return (
      <Modal
        title={sp_idf ? "Edição de Status da Produção" : "Cadastro de Status da Produção"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={18} className="camposEspacoDireita">
              <span>Descrição</span>
              <InputForm
                id="sp_descricao"
                ref="sp_descricao"
                maxLength={15}
                onChange={this.onChange}
                value={sp_descricao}
                validator={value => Boolean(value)}
                disabled={sp_descricao === 'PENDENTE' || sp_descricao === 'ENTREGUE' || sp_descricao === 'PRODUÇÃO'}
              />
            </Col>
            <Col xs={24} sm={6} className="camposEspacoDireita">
              <span>Abreviatura</span>
              <InputForm
                id="sp_abrev"
                ref="sp_abrev"
                maxLength={3}
                onChange={this.onChange}
                value={sp_abrev}
                validator={value => Boolean(value)}
                disabled={sp_descricao === 'PENDENTE' || sp_descricao === 'ENTREGUE' || sp_descricao === 'PRODUÇÃO'}
              />
            </Col>
            <Col xs={24} sm={24} >
              <span>Cores</span>
              <InputForm
                type="select"
                id="sp_cor"
                ref="sp_cor"
                value={sp_cor}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COR}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatusProducaoForm.js